const loadPromises = {}

export const loadScript = ({ id, src, code, crossorigin }) => {
  const scriptTag = document.getElementById(id)
  if (!scriptTag && !loadPromises[id]){
    loadPromises[id] = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.id = id
      if (crossorigin){
        script.crossorigin=crossorigin
      }
      if (src) {
        script.src = src
        script.onload = resolve
      } else if (code) {
        script.innerHTML = code
        resolve()
      } else {
        reject("missing script.")
        return
      }
      document.body.append(script)
    })
  }
  return loadPromises[id]
}
